import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { StyledCommonProps } from "../../utils/styled";
import FlexBox from "../containers/FlexBox";

import FieldGrid from "./FieldGrid";
import FormField from "./FormField";

const Styled = styled.div``;

const DoubleWidth = styled.div`
  grid-column: 1 / -1;
`;

interface FormProps extends React.FC<StyledCommonProps> {
  FieldGrid: typeof FieldGrid;
  FieldList: typeof FlexBox;
  Field: typeof FormField;
  DoubleWidth: typeof DoubleWidth;
}

const FormComponent: FormProps = ({
  className,
  children,
}: PropsWithChildren<any>) => {
  return <Styled className={className}>{children}</Styled>;
};

FormComponent.FieldGrid = FieldGrid;
FormComponent.FieldList = styled(FlexBox)`
  gap: 1rem;
`;
FormComponent.Field = FormField;
FormComponent.DoubleWidth = DoubleWidth;

const Form: any = styled(FormComponent)``;

export default Form;
